import { render, staticRenderFns } from "./dept-manage.vue?vue&type=template&id=3df1acfd&scoped=true"
import script from "./dept-manage.vue?vue&type=script&lang=js"
export * from "./dept-manage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3df1acfd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3df1acfd')) {
      api.createRecord('3df1acfd', component.options)
    } else {
      api.reload('3df1acfd', component.options)
    }
    module.hot.accept("./dept-manage.vue?vue&type=template&id=3df1acfd&scoped=true", function () {
      api.rerender('3df1acfd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/dept/dept-manage.vue"
export default component.exports